import React from 'react';

import { INotificationGridItem } from '../notification-grid';

import { DetailsRow } from './DetailsRow';
import { LeadInfo } from './utils';

export const CalendarEventDetails: React.FC<INotificationGridItem> = ({
  date,
  notificationDetails: { data },
}) => (
  <>
    <DetailsRow label="Date" value={date} />
    {data.leadId && (
      <DetailsRow
        label="Client ID"
        component={<LeadInfo leadId={data.leadId} />}
      />
    )}
    {data.leadFullName && <DetailsRow label="Name" value={data.leadFullName} />}
    <DetailsRow label="Event Name" value={data.eventName} />
    <DetailsRow label="Comment" value={data.description} />
  </>
);
